import { render, staticRenderFns } from "./SimpleTextCard.vue?vue&type=template&id=386fdb6c&scoped=true"
import script from "./SimpleTextCard.vue?vue&type=script&lang=js"
export * from "./SimpleTextCard.vue?vue&type=script&lang=js"
import style0 from "./SimpleTextCard.vue?vue&type=style&index=0&id=386fdb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386fdb6c",
  null
  
)

export default component.exports